import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Temoignage() {
  const { t } = useTranslation('toitplat');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="temoignage" className="bg-slate-primary py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Image */}
          <div
            className={`transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Quebec%20duplex%20residential%20building%20with%20brand%20new%20flat%20roof%20and%20grey%20elastomeric%20membrane%2C%20two%20story%20brick%20building%2C%20clean%20architectural%20lines%2C%20bright%20blue%20sky%20with%20white%20clouds%2C%20warm%20afternoon%20sunlight%2C%20suburban%20L%C3%A9vis%20neighborhood%2C%20professional%20real%20estate%20photography%2C%20no%20text%20visible&width=800&height=600&seq=toitplat-temoin1&orientation=landscape"
                alt="Duplex avec toit plat membrane élastomère neuve à Lévis par couvreur RBQ"
                className="w-full h-64 md:h-96 object-cover object-top"
                loading="lazy"
                width="800"
                height="600"
              />
            </div>
          </div>

          {/* Texte */}
          <div
            className={`transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="flex items-center gap-1 mb-5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-copper text-lg" />
              ))}
            </div>

            <blockquote className="text-white/80 text-base md:text-lg leading-relaxed mb-6">
              "{t('temoin_text')}"
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-copper flex items-center justify-center text-white font-bold text-sm">
                PL
              </div>
              <div>
                <p className="font-manrope font-bold text-white text-sm">{t('temoin_name')}</p>
                <p className="text-white/50 text-xs">
                  {t('temoin_location')} — {t('temoin_project')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-white/40 text-xs mt-10 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}